// import * as firebase from 'firebase/app'
import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyDwfZAkvi1CjoRTeo0G3hB7bl9hY1HVh_o",
  authDomain: "venom-amj.firebaseapp.com",
  projectId: "venom-amj",
  storageBucket: "venom-amj.appspot.com",
  messagingSenderId: "903957078970",
  appId: "1:903957078970:web:8a09e1ecf83aef5aa23383",
  measurementId: "G-RK884X3PSZ"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const messaging = firebase.messaging()

messaging.usePublicVapidKey("BChUVsvXo0Irh2OFdRDdws2dedjB306hsp8PRaNfmcKOZMHRzs2zpYpqpJxywDLOBhkYI3u35QvJ-KmS9ldS--s")

export default firebase